<div class="form-container">
    <br>  <br>
  <form [formGroup]="form">
      <br>
    <h1 class="title">Cadastro Novo convertido</h1>
    <br>

    <mat-form-field appearance="outline" id="name">
      <mat-label>Nome</mat-label>
      <input matInput placeholder="Nome" formControlName="name" name="name" autocomplete="name" />
      <mat-error *ngIf="form.controls.name.hasError('required')"> Obrigatorio </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" id="cpf">
      <mat-label>CPF</mat-label>
      <input matInput placeholder="CPF" formControlName="cpf" name="cpf" autocomplete="family-name"  maxlength="14" appCpfMaskTwo />
      <mat-error *ngIf="form.controls.cpf.hasError('required')"> Obrigatorio </mat-error>
      <mat-error *ngIf="form.controls.cpf.hasError('maxlength')">O máximo são 14 caracteres </mat-error>
    </mat-form-field>
    
    <div class="gender">
      <label id="example-radio-group-label">Sexo:</label>
      <div class="gender-container">
        <br />
        <mat-radio-group
        aria-label="Select an option"
        formControlName="gender"
        color="primary"
        class="gender"
        aria-autocomplete="both"
        >
        <mat-radio-button value="M">Masculino</mat-radio-button>
        <mat-radio-button value="F">Feminino</mat-radio-button>
        
        <mat-error *ngIf="form.controls.gender.hasError('required')"> Obrigatorio </mat-error>
      </mat-radio-group>
    </div>
  </div>
    <br />

    <mat-form-field appearance="outline">
      <mat-label>E-mail</mat-label>
      <input matInput placeholder="email" formControlName="email" autocomplete="email" />

      <mat-error *ngIf="form.controls.email.hasError('email')"> Email invalido </mat-error>
      <mat-error *ngIf="form.controls.email.hasError('required')"> Obrigatorio </mat-error>
      <mat-error *ngIf="form.controls.email.hasError('maxlength')">O máximo são 100 caracteres </mat-error>
    </mat-form-field>



    <mat-form-field appearance="outline">
      <mat-label>Celular</mat-label>
      <input matInput placeholder="(82) 98121-3141" formControlName="phone_number" appPhoneMask maxlength="14" />
      <mat-error *ngIf="form.controls.phone_number.hasError('required')"> Obrigatorio </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Data de nascimento</mat-label>
      <input matInput placeholder="email" formControlName="bhirth_date" type="date" />
      <mat-error *ngIf="form.controls.bhirth_date.hasError('required')"> Obrigatorio </mat-error>
    </mat-form-field>


    <mat-form-field appearance="outline">
      <mat-label>CEP</mat-label>
      <input
        formControlName="cep"
        autocomplete="off"
        type="text"
        matInput
        appCepMask
        placeholder="00000-000"
        maxlength="9"
      />
      <mat-error *ngIf="form.controls.cep.hasError('required')"> Obrigatorio </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>endereço</mat-label>
      <input matInput placeholder="endereço" formControlName="street" />
      <mat-error *ngIf="form.controls.street.hasError('required')"> Obrigatorio </mat-error>
      <mat-error *ngIf="form.controls.street.hasError('maxlength')">O máximo são 100 caracteres </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Complemento</mat-label>
      <input matInput placeholder="Complemento" formControlName="complement" />
      <mat-error *ngIf="form.controls.complement.hasError('maxlength')">O máximo são 100 caracteres </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" id="home_number">
      <mat-label>Nº</mat-label>
      <input matInput placeholder="nº" formControlName="home_number" />
      <mat-error *ngIf="form.controls.home_number.hasError('required')"> Obrigatorio </mat-error>
    </mat-form-field>

 
    <mat-form-field appearance="outline">
      <mat-label>Estado</mat-label>
      <mat-select matNativeControl (selectionChange)="changeCity($event.value)" formControlName="state_id">
        <mat-option *ngFor="let state of states" [value]="state.ID">
          {{ state.Nome }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Cidade</mat-label>
      <mat-select matNativeControl formControlName="city_id">
        <mat-option *ngFor="let city of cities" [value]="city.ID">
          {{ city.Nome }}
        </mat-option>
      </mat-select>
    </mat-form-field>
   


    <mat-form-field appearance="outline">
      <mat-label>Célula</mat-label>
      <select matNativeControl formControlName="group_id">
        <option value="">Selecione</option>
        <option value="">ainda não estou em célula</option>
        <option *ngFor="let group of groups" [value]="group.id">
          {{ group.name }}
        </option>
      </select>
      <mat-error *ngIf="form.controls.group_id.hasError('required')"> Obrigatorio </mat-error>
    </mat-form-field>


    <mat-form-field appearance="outline">
      <mat-label>Como se converteu ?</mat-label>
      <textarea matInput formControlName="how_arrived" placeholder="Conte-nos como se converteu..."></textarea>
      <mat-error *ngIf="form.controls.how_arrived.hasError('required')"> Obrigatorio </mat-error>
    </mat-form-field>
   
   
     <div style="display: flex; "> restam {{ 200 - form.controls.how_arrived.value.length }} caracteres </div>

   

    <div class="term">
      <p>Ao clicar em cadastrar você concorda com os nossos <a routerLink="/terms" target="_blank">Termos de uso</a></p>
    </div>


    <button *ngIf="!id" (click)="register()" mat-raised-button class="btn-primary">cadastrar</button>
    <br />
    <button mat-raised-button [routerLink]="['/']" class="btn-segundary">cancelar</button>
    <br />
    <br />
  </form>
</div>
